module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('div', {
    staticClass: "tabbar"
  }, [_vm._l((_vm.tabs), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "tabbar-item",
      attrs: {
        "to": item.path
      }
    }, [_c('div', {
      staticClass: "tabbar-icon"
    }, [_c('img', {
      attrs: {
        "src": item.icon
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "tabbar-indicator",
    style: ({
      width: _vm.indicatorWidth + 'px',
      transform: _vm.indicatorStyle
    })
  })], 2), _vm._v(" "), _c('keep-alive', [_c('router-view', {
    staticClass: "page-content"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a772af3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 346
// module chunks = 1